export default __webpack_public_path__ + "static/media/Bg.39aa994d.svg";